import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAccessToken } from '../../../redux/actions/auth'
import { Alert, Container } from 'react-bootstrap'
import Home from '../Home'
import Layout from '../../Layouts/Layout'

const Redirect = () => {
  const dispatch = useDispatch()
  const auth = useSelector((state) => state.auth)
  const assessment = useSelector((state) => state.assessment)

  useEffect(() => {
    dispatch(getAccessToken(window.location.href))
  }, [])

  if (auth.error !== null || assessment.error !== false) {
    return (
      <Layout showNav={false} showFooter={false}>
        <Container className='pt-5'>
          <Alert variant='danger'>
            <Alert.Heading>Error</Alert.Heading>
            <div>{auth.error !== null ? auth.error.description : 'Unable to generate assessment.'}</div>
          </Alert>
        </Container>
      </Layout>
    )
  }

  return <Home />
}

export default Redirect
